import { FolderId } from 'modules/domains/foldering';
import { CampaignId } from '../domainTypes';

export enum CampaignFolderActions {
  fetchRootFolderId = 'campaign-folders/fetch-root-folder-id',
  selectItems = 'campaign-folders/select-items',
}

export enum SelectionTypes {
  Campaign = 'Campaign',
  Folder = 'Folder',
}

export type CurrentSelection = {
  id: FolderId | CampaignId;
  name: string;
  type: SelectionTypes;
};

export type CampaignFolderState = {
  activeSelections: CurrentSelection[];
  rootFolderId: FolderId;
};

type FetchRootFolderIdAction = {
  rootFolderId: FolderId;
  type: CampaignFolderActions.fetchRootFolderId;
};

type SelectItemsAction = {
  selections: CurrentSelection[];
  type: CampaignFolderActions.selectItems;
};

type AllowedActions = SelectItemsAction | FetchRootFolderIdAction;

export const initialState: CampaignFolderState = {
  activeSelections: [],
  rootFolderId: 0,
};

export const selectCampaignsAndFolders = (selections: CurrentSelection[]) => ({
  type: CampaignFolderActions.selectItems,
  selections,
});

export function campaignFolderReducer(
  state: undefined | CampaignFolderState = initialState,
  action: AllowedActions,
) {
  switch (action.type) {
    case CampaignFolderActions.selectItems:
      return {
        ...state,
        activeSelections: action.selections,
      };
    case CampaignFolderActions.fetchRootFolderId:
      return {
        ...state,
        rootFolderId: action.rootFolderId,
      };
    default: {
      return state;
    }
  }
}
